module.exports = __webpack_public_path__ + "static/media/icon.44c8922b.svg";